import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getWishlist = createAsyncThunk('wishlist/getWishlist', async (_, { getState, rejectWithValue }) => {
    try {
        const { user: { userInfo } } = getState();
        if (!userInfo || !userInfo.token) {
            return rejectWithValue('Not authorized, please login');
        }
        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        const { data } = await axios.get('/api/users/wishlist', config);
        return data;
    } catch (error) {
        return rejectWithValue(error.response && error.response.data.message ? error.response.data.message : error.message);
    }
});

export const addToWishlist = createAsyncThunk('wishlist/add', async (id, { getState, rejectWithValue }) => {
    try {
        const { user: { userInfo } } = getState();
        if (!userInfo || !userInfo.token) {
            return rejectWithValue('Not authorized, please login');
        }
        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        await axios.post(`/api/users/wishlist/${id}`, {}, config);
        return id;
    } catch (error) {
        return rejectWithValue(error.response && error.response.data.message ? error.response.data.message : error.message);
    }
});

export const removeFromWishlist = createAsyncThunk('wishlist/remove', async (id, { getState, rejectWithValue }) => {
    try {
        const { user: { userInfo } } = getState();
        if (!userInfo || !userInfo.token) {
            return rejectWithValue('Not authorized, please login');
        }
        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        await axios.delete(`/api/users/wishlist/${id}`, config);
        return id;
    } catch (error) {
        return rejectWithValue(error.response && error.response.data.message ? error.response.data.message : error.message);
    }
});

const wishlistSlice = createSlice({
    name: 'wishlist',
    initialState: {
        wishlistItems: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getWishlist.pending, (state) => {
                state.loading = true;
            })
            .addCase(getWishlist.fulfilled, (state, action) => {
                state.loading = false;
                state.wishlistItems = action.payload;
            })
            .addCase(getWishlist.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(addToWishlist.fulfilled, (state, action) => {
                // We might want to re-fetch or optimistically update. 
                // For simplicity, we can just rely on getWishlist or handle it here if we had the full product object.
                // Since we only return ID, we can't easily add to wishlistItems if it expects full objects.
                // So typically we trigger a refetch or just handle the ID if we store IDs.
                // But getWishlist returns populated products.
                // Let's just trigger a refetch in the component or leave it as is.
            })
            .addCase(removeFromWishlist.fulfilled, (state, action) => {
                state.wishlistItems = state.wishlistItems.filter((x) => x._id !== action.payload);
            });
    },
});

export default wishlistSlice.reducer;
